<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template
      v-if="
        hasOneShowingChild(item.children, item) &&
        (!onlyOneChild.children || onlyOneChild.noShowingChildren) &&
        !item.alwaysShow
      "
    >
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <item
            :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
            :title="onlyOneChild.meta.title"
          />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <!-- <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" /> -->
        <item
          :class="'is-active'"
          v-if="item.meta && !item.newpath"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
        />

        <router-link
          :class="newclass.path.includes(item.path) == true ? 'is-active' : ''"
          v-else
          :to="item.newpath ? item.newpath : ''"
          ><i :class="item.meta.icon" />
          <span class="menu-text menu-text1">{{ item.meta.title }}</span>
        </router-link>
      </template>
      <sidebar-item
        :test1="item.newpath"
        :test2="item.path"
        :test3="newclass.path"
        :test4="newclass.path.includes(item.path)"
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
        :newclass="activeMenu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
    newclass: {
      type: Object,
      default: "",
    },
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null;
    return {};
  },
  computed: {
    activeMenu() {
      const route = this.$route;

      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      // return '/data/goods/world';

      // if(path.includes('detail')){
      //   return {
      //     path: deleteLastSegmentFromUrl(path),
      //     className: 'is-active'
      //   };
      // }
      function deleteLastSegmentFromUrl(url) {
        const lastSlashIndex = url.lastIndexOf("/");
        if (lastSlashIndex === -1 || lastSlashIndex === url.length - 1) {
          return url;
        }
        return url.substring(0, lastSlashIndex);
      }
      // //console.log(path, "path");

      return {
        path: path,
        className: "is-active",
      };
    },
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1 && !parent.meta.showOnlyOneChild) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
  },
};
</script>
<style scoped>
.is-active {
  /* 自定义样式 */
  color: #4193cf;
  /* 其他样式 */
}
.menu-text1 {
  margin-left: 12px;
  /* display: block; */
  display: inline-block;
  min-width: 95px;
  line-height: 25px;
  white-space: normal;
  word-break: break-all;
  overflow: hidden;
}
</style>
